import React, { useState, useEffect } from 'react';
import { rankAPI } from '../../api';
import LoadingSpinner from '../LoadingSpinner';

const UserRanks = () => {
  const [rankInfo, setRankInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchRankInfo();
  }, []);

  const fetchRankInfo = async () => {
    try {
      setLoading(true);
      const response = await rankAPI.getMyRank();
      setRankInfo(response.data);
      setError('');
    } catch (err) {
      setError('Failed to load rank information');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-screen"><LoadingSpinner fullPage={false} /></div>;
  if (error) return <div className="flex items-center justify-center min-h-screen text-red-600">{error}</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-bold text-secondary">Rank System</h2>
        <button
          onClick={fetchRankInfo}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          Refresh
        </button>
      </div>
      
      {rankInfo && (
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-primary mb-4">Your Current Rank</h3>
            <div className="text-6xl font-bold text-secondary mb-4">{rankInfo.currentRank.rankName}</div>
            <p className="text-gray-600">{rankInfo.currentRank.criteria}</p>
          </div>

          <div className="mb-8">
            <h4 className="text-lg font-semibold mb-4">Progress to Next Rank</h4>
            <div className="w-full bg-gray-200 rounded-full h-4 mb-2">
              <div 
                className="bg-gradient-to-r from-primary to-primary-light h-4 rounded-full transition-all duration-500" 
                style={{ width: `${rankInfo.progressPercentage}%` }}
              ></div>
            </div>
            <div className="text-center text-sm text-gray-600">
              {rankInfo.progressPercentage.toFixed(1)}% complete
            </div>
          </div>

          {rankInfo.nextRank && (
            <div className="text-center">
              <h4 className="text-lg font-semibold mb-2">Next Rank: {rankInfo.nextRank.rankName}</h4>
              <p className="text-gray-600">Need Rs. {rankInfo.businessToNextRank?.toLocaleString()} more business</p>
              <p className="text-sm text-primary">Reward: Rs. {rankInfo.nextRank.rewardAmount?.toLocaleString()}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserRanks;
